import { atom } from "recoil";
import { ATOMS_KEYS } from "../atom-keys";
interface IReservationDetails {
  bookingStatus: string;
  channelName: "Airbnb" | "GatherIn" | "Booking" | "Agoda" | "Msool";
  checkIn: string | Date;
  checkOut: string | Date;
  guestName: string;
  guestPhoneNumber: string;
  propertyId: string;
  propertyName: string;
  reservationId: string;
  /** MS-541 — the guest-facing "MSL-XXXXXX" reference. */
  bookingCode?: string | null;
  totalPrice: string;
  isMessageSend: string;
  isAutoAccess: boolean;
  isAbleToSendMessage: boolean;
  id: string;
  total?: any;
  isDirectPaymentAccepted?: boolean;
}
export const reservationDetails = atom<IReservationDetails | undefined>({
  key: ATOMS_KEYS.RESERVATIONDETAILS,
  default: undefined,
});
